import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.5 22.25C10.9142 22.25 11.25 21.9142 11.25 21.5C11.25 21.0858 10.9142 20.75 10.5 20.75V22.25ZM18.75 11.5C18.75 11.9142 19.0858 12.25 19.5 12.25C19.9142 12.25 20.25 11.9142 20.25 11.5H18.75ZM12.9393 2.93934L12.409 3.46967L12.9393 2.93934ZM19.0607 9.06066L19.591 8.53033L19.0607 9.06066ZM5.25 18.5V5.5H3.75V18.5H5.25ZM13 11.25H19.5V9.75H13V11.25ZM7.5 3.25H11.5V1.75H7.5V3.25ZM10.75 2.5V9H12.25V2.5H10.75ZM20.25 10.5V10.1213H18.75V10.5H20.25ZM19.591 8.53033L13.4697 2.40901L12.409 3.46967L18.5303 9.59099L19.591 8.53033ZM11.8787 1.75H11.5V3.25H11.8787V1.75ZM10.5 20.75H7.5V22.25H10.5V20.75ZM18.75 10.5V11.5H20.25V10.5H18.75ZM3.75 18.5C3.75 20.5711 5.42893 22.25 7.5 22.25V20.75C6.25736 20.75 5.25 19.7426 5.25 18.5H3.75ZM13.4697 2.40901C13.0477 1.98705 12.4754 1.75 11.8787 1.75V3.25C12.0776 3.25 12.2684 3.32902 12.409 3.46967L13.4697 2.40901ZM13 9.75C12.5858 9.75 12.25 9.41421 12.25 9H10.75C10.75 10.2426 11.7574 11.25 13 11.25V9.75ZM20.25 10.1213C20.25 9.52458 20.0129 8.95229 19.591 8.53033L18.5303 9.59099C18.671 9.73164 18.75 9.92241 18.75 10.1213H20.25ZM5.25 5.5C5.25 4.25736 6.25736 3.25 7.5 3.25V1.75C5.42893 1.75 3.75 3.42893 3.75 5.5H5.25Z"
            fill="currentColor"
        />
        <path
            d="M16 17.5L14.5 19M14.5 19L16.3916 22.3103C16.4341 22.3846 16.5442 22.3747 16.5727 22.294L19.4304 14.1972C19.4584 14.1179 19.3821 14.0416 19.3028 14.0696L11.206 16.9273C11.1253 16.9558 11.1154 17.0659 11.1897 17.1084L14.5 19Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
